/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import {
  Button,
  Dialog,
  Flex,
  InputField,
  SelectField,
  Typography,
  Snackbar
} from "../../../ppui";
import ErrorBoundary from "../../../utils/error-boundary";
import { ContentHeading, } from "../../style";
import DesignationList from "./designation-list";
import useDesignationService from "./use-designation-service";
import { DESIGNATION_INPUT_FIELDS } from "./designation-constant";


const OrganizationDesignation = () => {


  const { handleClickOpen, handleClose, open, departmentList, getInputFieldPropsFn, handleSubmitFn, desinagtionState, snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor, 
    designations,
    pagination,
    fetchDesignations
  } = useDesignationService()

  return (
    <>
      <ContentHeading>
        <Typography variant="h5" mb="0">
          Designation Management
        </Typography>

        <Button
          color="primary"
          variant="outlined"
          onClick={handleClickOpen}
          size="sm"
        // loading={loading}
        >
          Add New
        </Button>
      </ContentHeading>
      <ErrorBoundary
        fallback={<p>Something went wrong in fetching Designation List...</p>}
      >
        {/* <Suspense fallback={<p>Loading Designation...</p>}>
              <DesignationList
                resource={designations}
                handleClickOpen={handleClickOpen}
                departmentList={departmentList}
              />
            </Suspense> */}
        {designations ? (
          <DesignationList
            resource={designations}
            handleClickOpen={handleClickOpen}
            departmentList={departmentList}
            pagination = {pagination}
            fetchDesignations = {fetchDesignations}
          />
        ) : (
          <p>Loading Designation...</p>
        )}
      </ErrorBoundary>



      {/* Modal */}
      <Dialog
        title={`${desinagtionState?.designationId ? "Update" : "Create"} Designation`}
        closeButton={true}
        fullWidth
        maxWidth="xs"
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmitFn}
        separator
      >
        <Flex direction="column" width={"100%"} gap={"20"}>

          <SelectField


            {...getInputFieldPropsFn(DESIGNATION_INPUT_FIELDS.dept_id.name)}
            options={departmentList || []}

          />



          <InputField

            {...getInputFieldPropsFn(DESIGNATION_INPUT_FIELDS.designationName.name)}

          />

          <SelectField
            {...getInputFieldPropsFn(DESIGNATION_INPUT_FIELDS.status.name)}

          />
        </Flex>
      </Dialog>
      <Snackbar
        message={snackbarMessage}
        color={snackColor}
        variant="contained"
        size="medium"
        position="top-right"
        onClose={closeSnackbar}
        onOpen={snackbarVisible}
        loading={false}
        duration={3000}
      />
      {/* Modal */}
    </>
  );
};

export default OrganizationDesignation;
